import React from 'react';

const getScoreStyle = (score, type = 'health') => {
  if (type === 'bis') {
    if (score >= 70) return 'bg-[hsl(var(--bis-high))]/15 text-[hsl(var(--bis-high))]';
    if (score >= 40) return 'bg-[hsl(var(--bis-med))]/15 text-[hsl(var(--bis-med))]';
    return 'bg-[hsl(var(--bis-low))]/15 text-[hsl(var(--bis-low))]';
  }
  if (score >= 70) return 'bg-[hsl(var(--status-ok))]/15 text-[hsl(var(--status-ok))]';
  if (score >= 40) return 'bg-[hsl(var(--status-warn))]/15 text-[hsl(var(--status-warn))]';
  return 'bg-[hsl(var(--status-crit))]/15 text-[hsl(var(--status-crit))]';
};

export const ScorePill = ({ score, type = 'health', className = '' }) => {
  const style = getScoreStyle(score, type);
  return (
    <span
      className={`rounded-full px-2.5 py-1 text-xs font-semibold tabular-nums ${style} ${className}`}
      style={{ fontFamily: 'var(--font-display)' }}
      data-testid={type === 'bis' ? 'business-impact-score-pill' : 'health-score-pill'}
    >
      {typeof score === 'number' ? score.toFixed(0) : score}
    </span>
  );
};

export default ScorePill;
